
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  name: "ci-registration-modal",
})
export default class extends Vue {
  @Prop({ default: null }) gatingBannerLocation!: Nullable<string>;
  @Prop({ default: null }) onboardingType!: Nullable<string>;
  @Prop({ default: "" }) returnButtonText!: string;
  @Prop({ default: false }) softGating!: boolean;

  public get trackingOnboardingType(): Nullable<string> {
    return this.softGating && !this.onboardingType ? "gating-banner" : this.onboardingType;
  }

  public get modalId(): string {
    return this.softGating ? "modal-registration-soft-gating" : "modal-registration";
  }

  public closeModal(): void {
    this.$bvModal.hide(this.modalId);
  }
}
